/* =========================================================
   File: assets/sh_header-bottom.js
   Website: Capital Floorings
   Purpose:
   - Desktop mega menu hover/click
   - Mobile menu toggle
   - Mobile category accordions
========================================================= */

(function () {
  'use strict';

  function initHeaderBottom(section) {
    if (!section || section.dataset.initialized === 'true') {
      return;
    }

    section.dataset.initialized = 'true';

    var mega = section.querySelector('[data-sh-mega-menu]');
    var megaTrigger = section.querySelector('[data-sh-mega-trigger]');
    var megaPanel = section.querySelector('[data-sh-mega-panel]');
    var mobileToggle = section.querySelector('[data-sh-mobile-toggle]');
    var mobileMenu = section.querySelector('[data-sh-mobile-menu]');
    var mobileCategoryButtons = section.querySelectorAll('[data-sh-mobile-category-toggle]');
    var closeTimer = null;

    function isDesktop() {
      return window.matchMedia('(min-width: 990px)').matches;
    }

    function openMega() {
      if (!mega || !megaTrigger || !megaPanel) {
        return;
      }

      window.clearTimeout(closeTimer);
      mega.classList.add('is-open');
      megaTrigger.setAttribute('aria-expanded', 'true');
    }

    function closeMega() {
      if (!mega || !megaTrigger || !megaPanel) {
        return;
      }

      closeTimer = window.setTimeout(function () {
        mega.classList.remove('is-open');
        megaTrigger.setAttribute('aria-expanded', 'false');
      }, 130);
    }

    function closeMegaNow() {
      if (!mega || !megaTrigger) {
        return;
      }

      window.clearTimeout(closeTimer);
      mega.classList.remove('is-open');
      megaTrigger.setAttribute('aria-expanded', 'false');
    }

    function toggleMega() {
      if (!mega || !megaTrigger) {
        return;
      }

      if (mega.classList.contains('is-open')) {
        closeMegaNow();
      } else {
        openMega();
      }
    }

    if (mega && megaTrigger && megaPanel) {
      megaTrigger.addEventListener('mouseenter', function () {
        if (isDesktop()) {
          openMega();
        }
      });

      megaTrigger.addEventListener('mouseleave', function () {
        if (isDesktop()) {
          closeMega();
        }
      });

      megaPanel.addEventListener('mouseenter', function () {
        if (isDesktop()) {
          openMega();
        }
      });

      megaPanel.addEventListener('mouseleave', function () {
        if (isDesktop()) {
          closeMega();
        }
      });

      megaTrigger.addEventListener('click', function (event) {
        event.preventDefault();
        toggleMega();
      });

      megaTrigger.addEventListener('focus', function () {
        openMega();
      });
    }

    if (mobileToggle && mobileMenu) {
      mobileToggle.addEventListener('click', function () {
        var isHidden = mobileMenu.hidden;

        mobileMenu.hidden = !isHidden;
        mobileToggle.setAttribute('aria-expanded', isHidden ? 'true' : 'false');
      });
    }

    mobileCategoryButtons.forEach(function (button) {
      button.addEventListener('click', function () {
        var item = button.closest('.sh-mobile-category');

        if (!item) {
          return;
        }

        var content = item.querySelector('.sh-mobile-category__content');

        if (!content) {
          return;
        }

        var isHidden = content.hidden;

        content.hidden = !isHidden;
        item.classList.toggle('is-open', isHidden);
      });
    });

    document.addEventListener('click', function (event) {
      if (mega && !mega.contains(event.target)) {
        closeMegaNow();
      }
    });

    document.addEventListener('keydown', function (event) {
      if (event.key === 'Escape') {
        closeMegaNow();

        if (mobileMenu && !mobileMenu.hidden && mobileToggle) {
          mobileMenu.hidden = true;
          mobileToggle.setAttribute('aria-expanded', 'false');
        }
      }
    });

    window.addEventListener('resize', function () {
      if (!isDesktop()) {
        closeMegaNow();
      }
    });
  }

  function initAllHeaderBottoms() {
    document.querySelectorAll('[data-sh-header-bottom]').forEach(function (section) {
      initHeaderBottom(section);
    });
  }

  document.addEventListener('DOMContentLoaded', initAllHeaderBottoms);
  document.addEventListener('shopify:section:load', initAllHeaderBottoms);
})();